export function LoadingMark() {
  return (
    <div className="js-boot-mark" role="status" aria-label="Loading">
      <span className="js-boot-block js-boot-a" />
      <span className="js-boot-block js-boot-b" />
      <span className="js-boot-block js-boot-c" />
      <span className="js-boot-block js-boot-d" />
    </div>
  );
}
